// eslint-disable-next-line import/no-extraneous-dependencies
import 'regenerator-runtime/runtime'; // Required for ExcelJS to work with bare.min.js version (which in turn is required to prevent unsafe-eval)
import Excel from 'exceljs'
import { saveAs } from 'file-saver'

export default async function exportToExcelFromUpload(mergedArray, exportFileName) {

    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("Αποτελέσματα");

    mergedArray.forEach(item => {
        worksheet.addRow([`${item}`]);
    })

    const buf = await workbook.xlsx.writeBuffer()
    saveAs(new Blob([buf]), `${exportFileName}_Αποτελέσματα.xlsx`)

}